import tinycolor2 from 'tinycolor2';

export function getColorWithOpacity(color: string = '#000000', opacity: number): string {
  const rgba = tinycolor2(color).setAlpha(opacity).toRgb();
  return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${opacity})`;
}
